import { getHyperwalletUserStateValidator } from 'utils/validation/fieldValidationRules';

export const userStateForHyperwalletValid = (userCountry, userState) => {
  return !!userState && !getHyperwalletUserStateValidator(userCountry)(userState);
};
